import React, { useEffect, useRef, useState } from "react";
import { BrowserQRCodeReader } from "@zxing/browser";
import { Button } from "@/components/ui/button";
import { Camera, CameraOff } from "lucide-react";

export const DeliveryScanner = ({ onRead }) => {
  const [active, setActive] = useState(false);
  const [error, setError] = useState("");
  const video = useRef(null);
  const onReadRef = useRef(onRead);
  onReadRef.current = onRead;
  useEffect(() => {
    if (!active) return;
    let disposed = false;
    let controls;
    const reader = new BrowserQRCodeReader();
    reader.decodeFromConstraints({ video: { facingMode: { ideal: "environment" } }, audio: false }, video.current,
      (result, _, scanner) => {
        if (!result || disposed) return;
        scanner.stop();
        onReadRef.current(result.getText());
        setActive(false);
      }).then((scanner) => { controls = scanner; if (disposed) scanner.stop(); })
      .catch(() => { if (!disposed) { setError("Não foi possível abrir a câmara. Permite o acesso ou introduz o código manualmente."); setActive(false); } });
    return () => { disposed = true; controls?.stop(); };
  }, [active]);
  return (
    <div className="space-y-2">
      <Button type="button" variant="outline" className="rounded-full w-full" data-testid="scan-delivery-qr" onClick={() => { setError(""); setActive(!active); }}>
        {active ? <CameraOff className="w-4 h-4 mr-2" /> : <Camera className="w-4 h-4 mr-2" />}{active ? "Fechar câmara" : "Ler QR com a câmara"}
      </Button>
      {active && <video ref={video} muted playsInline className="w-full rounded-xl bg-black" data-testid="delivery-camera" />}
      {error && <p role="alert" className="text-sm text-destructive" data-testid="delivery-camera-error">{error}</p>}
    </div>
  );
};
